// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"26699ac1","345":"5586bfdb","386":"2b08bf4c","790":"cd08cb7c","851":"625104d2","946":"9cfe3521"}[chunkId] + ".chunk.css";
};